
// project imports
import MainLayout from "../layout/MainLayout";
import Applicants from "../views/applicants";
import Posts from "../views/posts";
import PreviewPostData from "../views/posts/preview";
import Users from "../views/users";

// dashboard routing

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/users",
      element: <Users />,
    },
    {
      path: "/applicants",
      element: <Applicants />,
    },
    {
      path: "/posts",
      element: <Posts />,
    },
    {
      path: "/preview_post",
      element: <PreviewPostData />,
    },
  ],
};

export default MainRoutes;
